<template lang="html">

 <section class="widgets">
  <div class="row">
   <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
                            <p style="position: absolute; color: White; top: 40%; left: 40%;">
                                <img src='../../assets/snakes.gif' /></p>
                        </div>
    <div class="col-md-12 grid-margin">
      <div class="card">
        <div class="card-body">
              <h4 class="card-title mb-0">Users Map</h4><br>
                                <div
                id="floating-panel"
                v-if="records.length > 0"
              >
                <a
                  v-on:click="newPoly()"
                  class="btn btn-success"
                >New Polygon</a>
              </div>
              <div v-if="sorted.length > 0" id="floating-panels">
                <download-excel
                  class="btn btn-success btn-sm"
                  :data="json_data"
                  :fields="json_fields"
                  name="filename.xls"
                >
                  Download Excel
                </download-excel>
              </div>
           <div id="map"></div>
           
             
        </div>
     </div>
    </div>
  </div>
  </section>
 </template>
<script lang="js">
import axios from 'axios'
var marker
var drawingManager
var all_overlays = []
export default {
  name: 'dashboard',
  data () {
    return {
      records: [],
      items: [],
      oMarker: [],
      stats: '',
      loading: false,
      sorted: [],
          json_fields: {
        'Name': 'name',
        'Email': 'email',
        'Phone': 'phone' ,
        'Latitude': 'lat',
        'Longitude': 'lon'
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
    }
  },
  mounted: function () {
    this.loadMap()
  },
  methods: {
    loadMap () {
      this.loading = true
      var mapCanvas = document.getElementById('map')
      var mapOptions = {
        center: new google.maps.LatLng(20.5937, 78.9629),
        zoom: 5,
        mapTypeId: google.maps.MapTypeId.HYBRID
      }
      var vm = this

      vm.map = new google.maps.Map(mapCanvas, mapOptions)
      axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/user/allusers?type=map',
        method: 'GET',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        this.records = response.data.data
        for (var i = 0; i < this.records.length; i++) {
          var id = this.records[i]._id
          var lat = this.records[i].location[0]
          var lon = this.records[i].location[1]
          var name = this.records[i].name
          var email = this.records[i].email
          var phone = this.records[i].phone
          // eslint-disable-next-line
          var latlngset = new google.maps.LatLng(lon, lat)
          var iconBase = 'http://maps.google.com/mapfiles/kml/pal4/icon49.png'
          // eslint-disable-next-line
          marker = new google.maps.Marker({
            map: vm.map,
            position: latlngset,
            icon: iconBase
          })
          vm.oMarker[i] = {
            m: marker,
            c: id
          }
          var content =
            '<table><tr><td colspan=2 style="padding-left:10px;"><p style="color:#ff6907;">Email: ' + email +
            '</p><p><a style="color:#333333">Phone: ' + phone +
            '</a></p><p style="font-size:14px;color:#333333;font-weight:500"><b>Name: ' + name +
            '</b></p></td></tr></table>'
          // eslint-disable-next-line
          var infowindow = new google.maps.InfoWindow()
          // eslint-disable-next-line
          google.maps.event.addListener(marker, 'click',
            (function (marker, content, infowindow) {
              return function () {
                infowindow.setContent(content)
                infowindow.open(vm.map, marker)
              }
            })(marker, content, infowindow)
          )
          this.loading = false;
        }
           vm.polygonArray = [];
          drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: ["polygon"]
            },
            polygonOptions: {
              editable: true
            }
          });
          drawingManager.setMap(vm.map);
          vm.stmap = 1;

          google.maps.event.addListener(
            drawingManager,
            "overlaycomplete",
            function(event) {
              all_overlays.push(event);
              event.overlay.set("editable", false);
              drawingManager.setMap(null);
            }
          );
          google.maps.event.addListener(
            drawingManager,
            "polygoncomplete",
            function(polygon) {
              for (var i = 0; i < polygon.getPath().getLength(); i++) {
                var poly = polygon
                  .getPath()
                  .getAt(i)
                  .toUrlValue(6);
                vm.polygonArray.push(poly);
              }
              vm.getDocs();
            }
          );
      }).catch(e => {
        this.loading = false;
        this.errors.push(e)
      })
    },
        newPoly: function() {
      this.polygonArray = [];
      this.sorted = []; /* added */
      for (var i = 0; i < all_overlays.length; i++) {
        all_overlays[i].overlay.setMap(null);
      }
      all_overlays = [];
      drawingManager.setMap(null);

      drawingManager.setMap(this.map);
    },
    getDocs: function() {
      var vm = this;
      var temp = [];
      let op = vm.polygonArray.map(e => {
        let temp = e.split(",");
        return { lat: Number(temp[0]), lng: Number(temp[1]) };
      });
      var temp = op;
      var Triangle = new google.maps.Polygon({ paths: temp });
      var tempr = [];
      var tempi = [];
      var res = [];
      for (var i = 0; i < vm.records.length; i++) {
        var lat = vm.records[i].location[1];
        var lng = vm.records[i].location[0];
        res[i] = google.maps.geometry.poly.containsLocation(
          new google.maps.LatLng(
            vm.records[i].location[1],
            vm.records[i].location[0]
          ),
          Triangle
        );
        if (res[i] === true) {
          var tyu = {
          id : vm.records[i]._id,
          lat : vm.records[i].location[0],
          lon : vm.records[i].location[1],
          phone : vm.records[i].phone,
          email : vm.records[i].email,
          name : vm.records[i].name
          };
          tempi.push(tyu);
           vm.sorted = tempi;
           vm.json_data = tempi;
        }
      }

    },
  }
}
</script>

<style scoped lang="scss">
#map {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
#floating-panels {
  left: 70%;
  padding: 5px;
  position: absolute;
  top: 20px;
  z-index: 1;
  color: #fff;
}

#floating-panel {
  left: 50%;
  padding: 5px;
  position: absolute;
  top: 20px;
  z-index: 1;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/forms/usermap.vue